<template>
  <vs-tabs :value="0">
    <vs-tab :label="getTabLabel(0)" @click="onClickTab(0)">
      <div>
        <search-nav @handleSearch="handleSearch">
          연도
          <vs-select autocomplete v-model="targetYear">
            <vs-select-item v-for="year in totalYear" :key="year" :text="year" :value="year" />
          </vs-select>
          <search-nav-item-field label="키워드" v-model="table.keyword" @keyupEvent="handleInput" />
        </search-nav>

        <div class="flex mb-4" style="justify-content: flex-end">
          <vs-button class="" color="secondary" @click="onClickNew"> 신규작성 </vs-button>
        </div>
        <vs-card>
          <vs-table stripe ref="table" :sst="true" :max-items="table.perPage" :data="table.list" :noDataText="$t('approval.결재문서가 없습니다')" @selected="handleItemClickDetail">
            <template slot="thead">
              <vs-th sort-key="id" style="min-width: 130px"><span class="w-full text-center">No.</span></vs-th>
              <vs-th sort-key="content$field_name" style="min-width: 130px"><span class="w-full text-center">사업명</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">담당 주무관</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">사업기간</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">사업금액(원)</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">사업장 주소</span></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="text-center">{{ (currentPage - 1) * table.perPage + indextr + 1 }}</vs-td>
                <vs-td class="text-center">{{ tr.field_name }}</vs-td>
                <vs-td class="text-center">{{ !!tr.manager_name ? tr.manager_name : "-" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.work_begin_at ? tr.work_begin_at : "" }} {{ !!tr.work_begin_at || !!tr.work_end_at ? "~" : "-" }}{{ !!tr.work_end_at ? tr.work_end_at : "" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.deposit_amount ? comma(tr.deposit_amount) : "-" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.address ? tr.address : "-" }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="lastPage ? lastPage : 1" v-model="currentPage" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </vs-card>
      </div>
    </vs-tab>
    <vs-tab :label="getTabLabel(1)" @click="onClickTab(1)"></vs-tab>
  </vs-tabs>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemProject from "@/components/nav/SearchNavItemProject";
import KPagination from "@/components/kPagination/kPagination";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemField from "@/components/nav/SearchNavItemField";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
export default {
  name: "FieldList",
  components: {
    SearchNavYearMonth,
    SearchNavItemField,
    SearchNavItemKeyword,
    KPagination,
    SearchNavItemProject,
    SearchNav,
  },
  data() {
    return {
      // 검색 네비게이션
      nav: {
        projectId: "",
        date: {year:new Date().getFullYear(), month:'01'},
        keyword: "",
        type: "",
        typeList: [],
        orderTarget: "created_at",
        orderDirection: "desc",
        searchTypes: [
          { text: "제목", value: "content$title" },
          { text: "작성자", value: "content$writer" },
        ],
        searchType: "content$title",
      },

      currentPage: 1,
      lastPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 7,
        keyword: "",
      },

      // 마지막 api 호출시 사용한 옵션
      apiLastLoadOptions: null,

      // 작업일 필터링된 년도
      totalYear: [],
      targetYear: "전체",
    };
  },
  created() {
    this.initBreadcrumb();
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
  },
  mounted() {
    this.loadFieldList();
    this.getTotalYear();
  },
  methods: {
    initBreadcrumb() {
      if (parseInt(this.projectId) === 3) {
        this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "사업 현황" }, { title: "도급·용역·위탁 사업", active: true }]);
        return;
      }

      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "사업장 현황" }, { title: "도급·용역·위탁 사업장", active: true }]);
    },
    async loadFieldList() {
      const projectId = this.projectId;
      const page = this.currentPage;
      const perPage = this.table.perPage;
      const keyword = this.table.keyword;

      const options = { projectId, code: "workplace-subcontract", keyword, page, perPage }

      if (this.targetYear !== "전체") {
        options.work_begin_before = `${this.targetYear}-01-31`;
        options.work_end_after = `${this.targetYear}-12-01`;
        console.log(options)
      }

      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("project/LOAD_FIELD_LIST", options);
      const fieldListInfo = this.$store.state.project.fieldListInfo;
      this.table.list = fieldListInfo.data;

      this.currentPage = fieldListInfo.current_page;
      this.lastPage = fieldListInfo.last_page;
      this.total = fieldListInfo.total;
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-workplace2-list" });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "field-workplace2-info" });
      }
    },
    onClickSearch() {
      this.loadList();
    },
    onClickSort(sortKey, asc) {
      this.sortKey = sortKey;
      this.asc = asc;
    },
    onChangePage(page) {
      this.page = page;
    },
    onClickDownload() {
      this.popup.excel = true;
    },
    onClickNew() {
      this.$router.push({ name: "field-workplace2-create" });
    },
    onClickClose() {
      const keys = Object.keys(this.popup);
      keys.map((key) => {
        this.popup[key] = false;
      });
    },
    onClickDetail(value, target) {},

    handleItemClickDetail(data) {
      this.$router.push({ name: "field-workplace2-update", params: { proj_id: this.$route.params.proj_id, postId: data.id } });
    },

    handleChangePage(page) {
      this.currentPage = page;
      this.loadFieldList();
    },
    // 사업장 검색 폼에서 Enter 키가 눌렸을 때
    handleInput(data) {
      this.table.keyword = data;
      this.handleSearch();
    },
    // "검색" 버튼이 클릭됐을 때
    handleSearch() {
      this.loadFieldList();
    },
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getTabLabel(index) {
      let label = "사업장";
      if (parseInt(this.projectId) === 3) {
        label = "사업";
      }
      return `${label} ${index === 0 ? "등록" : "현황"}`;
    },
    // 작업일 필터링된 년도를 불러옵니다.
    async getTotalYear() {
      const projectId = this.projectId;
      const page = this.currentPage;
      const perPage = Number.MAX_SAFE_INTEGER;

      const options = { projectId, code: "workplace-subcontract", page, perPage }
      await this.$store.dispatch("project/LOAD_FIELD_LIST", options);
      const list = this.$store.state.project.fieldListInfo;
      const result = [...new Set(list.data.reduce((acc, item) => {
        const years = this.getYearRange(item.work_begin_at, item.work_end_at);
        acc.push(...years);
        return acc;
      }, []))].sort((a, b) => a - b);
      result.unshift("전체");
      this.totalYear = result;

    },
    // 시작일과 종료일 사이의 연도를 구합니다.
    getYearRange(beginDate, endDate) {
      if (!beginDate || !endDate) {
        return [];
      }

      const startYear = new Date(beginDate).getFullYear();
      const endYear = new Date(endDate).getFullYear();
      const years = [];

      for (let year = startYear; year <= endYear; year++) {
        years.push(year);
      }

      return years;
    },
  },
};
</script>

<style scoped></style>
